import { ref, watch, computed, onMounted } from "@vue/composition-api";
import store from "@/store";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import chartColorPalettes from "./components/chartColorPalettes";

export default function useLmsDashboard(
  selectedCourse,
  dateFilterId,
  selectedStartDate,
  selectedEndDate
) {
  const { t } = useI18nUtils();
  const completedCoursesData = ref(null);
  const completedCourseDataByDepartment = ref(null);
  const courseCompletePendingList = ref(null);
  const courseSubscriberExamResult = ref(null);
  const courseCompletedHours = ref(null);
  const startDate = ref(null);
  const endDate = ref(null);

  const fetchDashboardData = () => {
    store
      .dispatch("app-lms-dashboard/fetchDashboardData", {
        courseguid: selectedCourse.value,
        dateFilterId: dateFilterId.value,
        startDate: new Date(selectedStartDate.value),
        endDate: new Date(selectedEndDate.value),
      })
      .then((data) => {
        console.log(data);

        completedCoursesData.value = data.completedCoursesData;
        completedCourseDataByDepartment.value =
          data.completedCourseDataByDepartment;
        courseCompletePendingList.value = data.courseCompletePendingList;
        courseSubscriberExamResult.value = data.courseSubscriberExamResult;
        courseCompletedHours.value = data.courseCompletedHours;
        startDate.value = data.startDate;

        endDate.value = data.endDate;
        console.log(completedCoursesData.value.chartData);
      });
  };

  onMounted(() => {
    store.dispatch("app-lms-dashboard/fetchCourses");
    fetchDashboardData();
  });
  const completedCoursesChart = computed(() => {
    if (completedCoursesData.value == null) return null;
    const options = {
      widgetType: "HighchartColumn",
      title: {
        text: t(completedCoursesData.value.chartName),
      },
      colors: [
        chartColorPalettes.gradientColorList.green,
        chartColorPalettes.gradientColorList.orange,
      ],
      series: JSON.parse(JSON.stringify(completedCoursesData.value.chartData)),
    };
    return options;
  });

  console.log(completedCoursesChart.value);
  const completedCourseByDepartmentChart = computed(() => {
    if (completedCourseDataByDepartment.value == null) return null;
    const options = {
      widgetType: "HighchartColumn",
      colors: [
        chartColorPalettes.gradientColorList.green,
        chartColorPalettes.gradientColorList.orange,
      ],
      title: {
        text: t("Completed Courses By Department"),
      },
      xAxis: {
        type: "category",
        categories: completedCourseDataByDepartment.value.chartCategories,
      },
      series: completedCourseDataByDepartment.value.chartData,
    };
    return options;
  });

  const courseSubscriberExamResultChart = computed(() => {
    if (courseSubscriberExamResult.value == null) return null;
    const options = {
      widgetType: "HighchartColumn",
      title: {
        text: t(courseSubscriberExamResult.value.chartName),
      },
      colors: [
        chartColorPalettes.gradientColorList.green,
        chartColorPalettes.gradientColorList.red,
      ],
      series: courseSubscriberExamResult.value.chartData,
    };
    return options;
  });
  const courseTimeSpent = computed(() => {
    if (courseCompletedHours.value == null) return null;
    const options = {
      widgetType: "HighchartColumn",
      title: {
        text: t(courseCompletedHours.value.chartName),
      },
      colors: [chartColorPalettes.gradientColorList.blue],
      xAxis: {
        type: "category",
        categories: courseCompletedHours.value.chartCategories,
      },
      series: courseCompletedHours.value.chartData,
    };
    return options;
  });

  //implement charts

  return {
    startDate,
    endDate,
    courseCompletePendingList,
    fetchDashboardData,
    courseTimeSpent,
    completedCoursesChart,
    completedCourseByDepartmentChart,
    courseSubscriberExamResultChart,
  };
}
